// Ecommerce/Order/OrderValidate
import React, { Component } from 'react'
import { Container, Card, CardBody, CardFooter, Input, InputGroup, InputGroupAddon } from 'reactstrap'
import { Button, Icon, Radio, Spin, Row, Col, notification } from 'antd'
import { CheckUserLogedin, getAccId } from '../../../../config'
import { apiClient, urlClientInfo } from '../../../../api'
import { token, set_cookie, getExpiredDate } from '../../../../config'
import queryString from 'query-string'
import { TransectionErrorType } from "../../../../models/transection"
import PaymentValidateMobileBanking from '../../../../components/Payment/PaymentValidateMobileBanking'

class OrderValidate extends Component {
    constructor(props) {
        super(props)

        this.state = {
            errormessage: "",
            loading: true,
            statusmessage: "Checking your order.",
            statusdescription: null,
            statusred: false,
            redirectUrl: "",
            showCreateOrderButton: false,
            showRefreshButton: false,
            name: null,
            mobile: null,
            branch: null,
            idcard: null,
            address: null,
            province: null,
            district: null,
            subdistrict: null,
            post: null,
            savedefault: true,
            new_taxvoice: true,
            taxvoice_id: null,
            infolist: null,
            discountcode: null,
            tmpvalue: null,
            sourceType: null,
            expireOrderDate: null,
            timeRemaining: { minutes: 0, seconds: 0 },
            paymentLoading: false
        }

        this.countdownInterval = null
        this.getTaxinfo = this.getTaxinfo.bind(this)
        this.checkOrderStatus = this.checkOrderStatus.bind(this)
        this.setMessage = this.setMessage.bind(this)
        this.setUrl = this.setUrl.bind(this)
    }

    async componentDidMount() {
        const oid = queryString.parse(this.props.location.search).oid
        if (!CheckUserLogedin() || oid === undefined) {
            this.props.history.push("/404")
        } else {
            const taxInfoResult = await this.getTaxinfo()
            if (taxInfoResult) {
                this.setState({ discountlist: sessionStorage.getItem("discount") }, () => { console.table(this.state.discountlist) })
                await this.getClientInfo()
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.countdownInterval)
    }

    startCountdown() {
        if (this.state.expireOrderDate) {
            const targetTime = new Date(this.state.expireOrderDate)
            this.countdownInterval = setInterval(() => {
                const now = new Date()
                const timeDifference = targetTime - now

                if (timeDifference > 0) {
                    const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60))
                    const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000)
                    this.setState({ timeRemaining: { minutes, seconds } })
                } else {
                    clearInterval(this.countdownInterval)
                    this.setState({ timeRemaining: { minutes: 0, seconds: 0 } })
                    window.location.reload()
                }
            }, 1000)
        }
    }

    setUrl(url, time = 3000) {
        setTimeout(() => {
            this.props.history.push(url)
        }, time)
    }

    setMessage(message, description = null, isred = false) {
        this.setState({
            statusmessage: String(message).replace("_", " "),
            statusdescription: description,
            statusred: isred
        })
    }

    async getClientInfo() {
        urlClientInfo.get(''
            , { headers: {} })
            .then(response => {
                this.setState({
                    clientInfo: {
                        ipString: response.data.ipString,
                        userAgent: response.data.userAgent
                    }
                }, () => {
                    this.checkOrderStatus()
                })
            })
            .catch(error => {
                this.setState({ clientInfo: "" })
            })
    }

    async getTaxinfo() {
        const oid = queryString.parse(this.props.location.search).oid
        let req = JSON.stringify({
            OrderId: oid,
        })
        let result = false
        await apiClient
            .post("api/Ecom/GetTaxInvoiceByOderId", req, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-type": "application/json; charset=UTF-8",
                },
            })
            .then((response) => {
                this.setState({
                    infolist: {
                        taxvoice_id: response.data.ti_id,
                        type: response.data.ti_type,
                        name: response.data.ti_name,
                        mobile: response.data.ti_mobile,
                        idcard: response.data.ti_idcard,
                        address: response.data.ti_address,
                        branch: response.data.ti_branch,
                        province: response.data.ti_province,
                        district: response.data.ti_district,
                        subdistrict: response.data.ti_subdistrict,
                        post: response.data.ti_post,
                        new_taxvoice: response.data.savedefault ? false : true,
                        savedefault: response.data.savedefault,
                        requestTax: response.data.requestTax
                    },
                })
                result = true
                return result
            })
            .catch((error) => {
                notification.open({
                    message: "Error",
                    description: error,
                    top: 60,
                    className: "rti_form r",
                })
            })
        return result
    }

    checkOrderStatus() {
        const oid = queryString.parse(this.props.location.search).oid
        let req = {
            "oid": oid,
            "client": this.state.clientInfo,
            "TaxInfo": this.state.infolist,
        }

        if (this.state.discountlist) {
            req.discount = JSON.parse(this.state.discountlist)
        }

        apiClient.post('api/ecom/validateOrder', JSON.stringify(req),
            { headers: { 'Authorization': `Bearer ${token}`, 'Content-type': 'application/json; charset=UTF-8' } })
            .then(response => {
                this.handleEventOrderStatus(response.data)
            })
            .catch(error => {
                this.setMessage(error.message, "Please try again later. Or contact support with order id : " + queryString.parse(this.props.location.search).oid, true)
                this.setState({
                    showRefreshButton: true
                })
            })
            .finally(f => {
                this.setState({
                    loading: false,
                })
            })
    }

    handleEventOrderStatus(response) {
        switch (response.status) {
            case TransectionErrorType.ERROR:
                this.setMessage(response.message, response.description, true)
                this.setState({
                    redirectUrl: response.redirectTarget,
                    showCreateOrderButton: true
                })
                this.setUrl(response.redirectTarget, 0)
                break
            case TransectionErrorType.CREATE_RECEIPT:
            case TransectionErrorType.ADD_CREDIT_LOG:
            case TransectionErrorType.INNTERNAL_ERROR:
            case TransectionErrorType.NOT_FOUND_ORDER:
            case TransectionErrorType.ERR_UPDATE_ACCPRICE:
                this.setMessage(response.message, response.description, true)
                break
            case TransectionErrorType.UPDATE_STATUS_ORDER_FAIL:
                this.setMessage(response.message, response.description)
                this.setState({
                    showRefreshButton: true
                })
                break
            case TransectionErrorType.OMISE_CHARGE_NOT_SUCCESS:
                this.setMessage(response.message, response.description)
                this.setState({
                    redirectUrl: response.redirectTarget,
                    showCreateOrderButton: true
                })
                this.setUrl(response.redirectTarget, 0)
                break
            case TransectionErrorType.ORDER_PENDING:
                this.setMessage(response.message, response.description)
                this.setState({
                    showRefreshButton: true,
                    tmpvalue: response.tmpvalue,
                    sourceType: response.sourceType,
                    expireOrderDate: response.order_expire_date
                })
                this.startCountdown()
                break
            case TransectionErrorType.ORDER_FAILED:
            case TransectionErrorType.ORDER_REVERSED:
            case TransectionErrorType.ORDER_EXPIRED:
                this.setMessage(response.message, response.description)
                this.setState({
                    redirectUrl: response.redirectTarget,
                    showCreateOrderButton: true
                })
                this.setUrl(response.redirectTarget, 0)
                break
            case TransectionErrorType.SUCCESS:
                this.setMessage(response.message, response.description)
                this.setUrl(response.redirectTarget)
                break
            default:
                this.setMessage(response.message, response.description)
                break
        }
    }

    render() {
        let { statusmessage, statusdescription, statusred, showCreateOrderButton,
            showRefreshButton, redirectUrl, loading, tmpvalue,
            expireOrderDate, timeRemaining, paymentLoading, sourceType } = this.state

        return (
            // <div className="app flex-row align-items-center orderdetailbg">
            <div className="app flex-row align-items-center orderdetailbg">
                <Col xs={0} lg={8} xl={12}>&nbsp;</Col>
                <Col xs={24} lg={16} xl={12}>
                    {/* <Card className="mx-4">
                        <CardBody className="p-4">
                            <Row>
                                <Row className="text-center">
                                    <img style={{ width: "auto", maxWidth: "400px" }} src={tmpvalue} width="400px" />
                                </Row>
                                <Col className={statusred ? "justify-content-center order-status-error" : "justify-content-center"}>
                                    <Row className="text-center" style={{ display: tmpvalue !== null ? 'block' : 'none' }}>
                                        <Col xs={24} style={{ fontSize: "30px" }}>
                                            {
                                                timeRemaining.minutes > 0 || timeRemaining.seconds > 0
                                                    ? `Please pay within ${timeRemaining.minutes.toString().padStart(2, '0')}:${timeRemaining.seconds.toString().padStart(2, '0')}`
                                                    : `Processing...`
                                            }
                                        </Col>
                                    </Row>
                                    <Row className="text-center"><Col xs={24}>{statusmessage}</Col></Row>
                                    {(statusdescription != "" && statusdescription != null)
                                        ? <Row><Col xs={24} className="text-center">{statusdescription}</Col></Row>
                                        : null
                                    }
                                    {(showCreateOrderButton) ?
                                        <Row className="mt-2">
                                            <Col xs={24} className="text-center">
                                                <Button type="dash" style={{}} onClick={() => this.setUrl(redirectUrl, 0)}>Create new order</Button>
                                            </Col>
                                        </Row>
                                        : null
                                    }
                                    {(showRefreshButton) ?
                                        <Row className="mt-2">
                                            <Col xs={24} className="text-center">
                                                <Button type="dash" style={{}} onClick={() => window.location.reload()}>Check your order again</Button>
                                            </Col>
                                        </Row>
                                        : null
                                    }
                                </Col>
                            </Row>
                            {loading ?
                                <Row className="mt-4">
                                    <Col className="d-flex justify-content-center">
                                        <Spin size="large" />
                                    </Col>
                                </Row>
                                : null
                            }
                        </CardBody>
                    </Card> */}
                    <PaymentValidateMobileBanking
                        showCreateOrderButton={showCreateOrderButton}
                        redirectUrl={redirectUrl}
                        loading={paymentLoading}
                        sourceType={sourceType}
                        mobileBankingUrl={tmpvalue}
                        statusDescription={statusdescription}
                        statusMessage={statusmessage}
                        expireDatetime={expireOrderDate} 
                    />
                    
                </Col>
            </div>
        )
    }
}

export default OrderValidate
